/**
 * Ensures Buffer is available globally before any other app code runs.
 * Required by create-hash (used by jsonwebtoken) which expects global Buffer.
 */
import { Buffer } from 'buffer';

if (typeof globalThis.Buffer === 'undefined') {
  (globalThis as typeof globalThis & { Buffer: typeof Buffer }).Buffer = Buffer;
}

if (
  typeof window !== 'undefined' &&
  typeof (window as Window & { Buffer?: typeof Buffer }).Buffer === 'undefined'
) {
  (window as Window & { Buffer: typeof Buffer }).Buffer = Buffer;
}
